import { MessageCircle, Phone, MapPin, Clock } from "lucide-react";
import { useSettings } from "../lib/settings";
import { waLink, generalMessage, waNumberDisplay } from "../lib/wa";
import { Reveal, SectionHeading } from "../components/Reveal";
import { WhatsAppButton } from "../components/WhatsApp";
import { Watermark } from "../components/Gunungan";

export default function ContactPage() {
  const settings = useSettings();
  const wa = waLink(settings, generalMessage());
  const cards = [
    {
      icon: MessageCircle,
      title: "WhatsApp",
      value: settings?.wa_number || "085181800085",
      sub: "Hubungi via Chat",
      href: wa,
      testId: "kontak-card-wa",
    },
    {
      icon: Phone,
      title: "Telepon",
      value: settings?.phone || "085181800085",
      sub: "Hubungi",
      href: settings?.phone ? `tel:${settings.phone}` : null,
      testId: "kontak-card-telepon",
    },
    {
      icon: MapPin,
      title: "Alamat / Basecamp",
      value: settings?.alamat || "Kabupaten Brebes",
      sub: "Jawa Tengah, Indonesia",
      testId: "kontak-card-alamat",
    },
    {
      icon: Clock,
      title: "Jam Operasional",
      value: settings?.jam_operasional || "24 Jam",
      sub: "Siap Melayani Setiap Hari",
      testId: "kontak-card-jam",
    },
  ];

  return (
    <section className="relative overflow-hidden">
      <Watermark className="pointer-events-none absolute right-[-70px] top-16 hidden h-[460px] w-auto text-navy opacity-[0.05] lg:block" />
      <div className="wrap relative py-16 sm:py-24">
        <SectionHeading
          eyebrow="Kontak"
          title={<>Butuh Layanan Pengiriman untuk Bisnis Anda?</>}
          description="Konsultasikan kebutuhan pengiriman barang dan transportasi bisnis Anda dengan tim kami — langsung melalui WhatsApp."
        />
        <Reveal delay={0.2} className="mt-10">
          <WhatsAppButton
            settings={settings}
            message={generalMessage()}
            testId="kontak-wa-cta"
            variant="wa"
            size="lg"
          >
            HUBUNGI KAMI
          </WhatsAppButton>
        </Reveal>

        <div className="mt-16 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {cards.map((c, i) => (
            <Reveal key={c.title} delay={0.06 * i}>
              <div
                data-testid={c.testId}
                className="h-full rounded-2xl border border-zinc-800 bg-card p-6 transition-all duration-300 hover:-translate-y-1 hover:border-gold/50"
              >
                <c.icon className="h-6 w-6 text-gold" strokeWidth={1.75} />
                <h3 className="mt-4 font-display text-lg font-bold text-navy">{c.title}</h3>
                <p className="mt-2 text-sm font-semibold leading-relaxed text-[#1a1a1a]">{c.value}</p>
                {c.href ? (
                  <a
                    href={c.href}
                    target={String(c.href).startsWith("http") ? "_blank" : undefined}
                    rel="noopener noreferrer"
                    data-testid={`${c.testId}-link`}
                    className="mt-2 inline-flex items-center gap-1.5 text-sm text-gold-deep hover:underline"
                  >
                    {c.sub}
                  </a>
                ) : (
                  <p className="mt-2 text-sm text-zinc-500">{c.sub}</p>
                )}
              </div>
            </Reveal>
          ))}
        </div>

        {settings?.maps_url && (
          <Reveal className="mt-10 overflow-hidden rounded-2xl border border-zinc-800">
            <iframe
              title="Lokasi Putra Bengawan Logistik"
              src={settings.maps_url}
              className="h-[380px] w-full"
              loading="lazy"
            />
          </Reveal>
        )}

        <p className="mt-10 font-mono text-xs text-zinc-500" data-testid="kontak-wa-note">
          Nomor WhatsApp: {waNumberDisplay(settings)}
        </p>
      </div>
    </section>
  );
}
